// src/components/FiltersBar.js
import React from 'react';
import { Search, Download, Upload } from 'lucide-react';

const FiltersBar = ({ 
  filter, 
  setFilter, 
  searchTerm, 
  setSearchTerm,
  statusConfig,
  onExport,
  onImport
}) => {
  const handleImportClick = () => {
    document.getElementById('import-file').click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onImport(file);
      e.target.value = ''; // Reset input
    }
  };

  return (
    <div className="container">
      <div className="filters-card">
        <div className="filters-content">
          <div className="search-box">
            <Search className="search-icon" />
            <input
              type="text"
              placeholder="Rechercher une boutique..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="filter-buttons">
            {['all', 'scrapped', 'review', 'validated'].map(f => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                className={`filter-btn ${filter === f ? 'active' : ''} ${f !== 'all' ? f : 'all'}`}
              >
                {f === 'all' ? 'Tous' : statusConfig[f]?.label}
              </button>
            ))}
          </div>
          <div className="export-buttons">
            <button onClick={onExport} className="btn-export" title="Exporter les boutiques">
              <Download className="icon" />
              Export
            </button>
            <button onClick={handleImportClick} className="btn-import" title="Importer des boutiques">
              <Upload className="icon" />
              Import
            </button>
            <input
              id="import-file"
              type="file"
              accept=".csv,.xlsx,.xls"
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiltersBar;